import { render, staticRenderFns } from "./RecordAndVivaUpdateScore.vue?vue&type=template&id=70b768ab&scoped=true"
import script from "./RecordAndVivaUpdateScore.vue?vue&type=script&lang=js"
export * from "./RecordAndVivaUpdateScore.vue?vue&type=script&lang=js"
import style0 from "./RecordAndVivaUpdateScore.vue?vue&type=style&index=0&id=70b768ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b768ab",
  null
  
)

export default component.exports